import * as React from 'react';
import {ReactElement} from 'react';
import {useDispatch} from 'react-redux';
import INcaseLogo from '../../../../../assets/images/ui/incase-logo-black.svg';
import MediaImage from '../../../../incase-domain/components/media/MediaImage';
import {IElementImage} from '../../../../incase-domain/elements/image';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import {getBorderStyle} from '../../../../util/style.utils';

interface ElementImageProps {
    element: IElementImage;
}

function ElementImage(props: ElementImageProps): ReactElement {
    const dispatch = useDispatch();

    const {element} = props;
    const {slideChange, borderRadius} = element;

    return (
        <div className="c-imageElement" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
            <MediaImage
                src={element.imageSrc}
                fallbackSrc={INcaseLogo}
                title={element.title}
                alt=""
                style={{
                    borderRadius: getBorderStyle(borderRadius),
                }}
            />
        </div>
    );
}

export default ElementImage;
